import axiosInstance from '../../../core/api/axios';
import {
  DiagnosisSimulatedCheckResponse,
  RequestLevelingDto,
  RequestOnBoardingGoalsDto,
} from '../models/onboarding.model';

export async function getLevelingResult() {
  try {
    const response = await axiosInstance.get(`/leveling`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function SubmitOnboardingGoals(params: RequestOnBoardingGoalsDto) {
  try {
    const response = await axiosInstance.post(`/leveling`, params);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function submitLeveling(params: RequestLevelingDto) {
  try {
    const response = await axiosInstance.put(`/leveling`, params);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getToursSchedule(startDate: string, endDate: string) {
  try {
    const response = await axiosInstance.get(
      `/aprovaonboarding/${startDate}/${endDate}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function doTourRegistration(tourId: string) {
  try {
    const response = await axiosInstance.post(
      `/aprovaonboarding/webinar/registrant`,
      {
        onboarding: tourId,
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export interface OnboardingJoinResponse {
  signature: string;
  zoomToken: string;
  webinarId: number;
}

/**
 * Entra na live de onboarding E marca presença.
 * Não envolve o erro em `new Error` de propósito: precisamos preservar o
 * `error.response.status` (403/409/422) para o tratamento no hook.
 */
export async function joinOnboardingWebinar(
  onboardingId: string
): Promise<OnboardingJoinResponse> {
  const response = await axiosInstance.post(`/aprovaonboarding/webinar/join`, {
    onboarding: onboardingId,
  });

  return response.data;
}

export async function getDiagnosisSimulatedCheck(): Promise<DiagnosisSimulatedCheckResponse> {
  try {
    const response = await axiosInstance.get(`/diagnosis-simulated/active/check`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
